import { HTMLGenricComponent } from "./../htmlComponent/HTML-Genric-Component.JSON";
import { CellLevelValidationJSON } from "./../questionPage/Cell-Level-Validation.JSON";

export class CellComponentRequestJSON {
    questionID: Number;
    questionOptionID: Number;
    questionColumnID: Number;
    syscomponentTypeID: Number;
    hasPipedCellDetails: boolean;
    isCellLevelValidationActivated: boolean;
    isMandatoryValidationActivated: boolean;
    isVisibleValidationActivated: boolean;
    cellTrackerID: Number;
    rowIndex: Number;
    columnIndex: Number;
    cellInputHTMLComponentJSONList: HTMLGenricComponent[];
    cellValidationJSONList: CellLevelValidationJSON[];
    cellLinkedToQuestion: boolean;
    selectedDropValue: Number;
    selectedCheckBoxes: Number[];
    selectedRadio: Number;
    cellErrorMessage:string="";
    
    constructor() {
        this.cellInputHTMLComponentJSONList = new Array<HTMLGenricComponent>();
        this.cellValidationJSONList = new Array<CellLevelValidationJSON>();
    }
}